/* Buy-box behaviour for the shared product card (snippets/brand-product-card).

   Lifted out of zen-home.liquid's inline script so the Precise grid gets the
   same behaviour without a second copy.

   The radios carry their own copy in data-* attributes, so this only moves
   strings around. No prices are computed here: Liquid already worked them out
   against the real variant and its selling plan. Removing the selling_plan
   input on "buy once" is what actually changes the order. */
(function () {
  'use strict';

  /* Free launch offer panels (.zh-offer) sit at the foot of their card. A long
     product name wraps the "Try ... free" title onto two lines and makes that
     panel taller than its neighbours; this gives every panel in a row the
     height of the tallest one. Re-run on resize and when a grid is drawn by
     script (the Precise All formulas page). */
  function equalizeOffers() {
    var panels = Array.prototype.filter.call(document.querySelectorAll('.zh-card .zh-offer, .pp-card .zh-offer'), function (p) { return p.offsetParent; });
    panels.forEach(function (p) { p.style.minHeight = ''; });
    var rows = {};
    panels.forEach(function (p) {
      var card = p.closest('.zh-card, .pp-card');
      var key = (card.parentElement && card.parentElement.className) + '|' + Math.round(card.getBoundingClientRect().top + window.scrollY);
      (rows[key] = rows[key] || []).push(p);
    });
    Object.keys(rows).forEach(function (k) {
      var row = rows[k];
      if (row.length < 2) return;
      var h = Math.max.apply(null, row.map(function (p) { return p.offsetHeight; }));
      row.forEach(function (p) { p.style.minHeight = h + 'px'; });
    });
  }
  var eqT;
  function eqSoon() { clearTimeout(eqT); eqT = setTimeout(equalizeOffers, 80); }
  window.addEventListener('resize', eqSoon, { passive: true });
  window.addEventListener('load', eqSoon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(eqSoon);
  document.addEventListener('DOMContentLoaded', eqSoon);
  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var n = list[i].addedNodes;
        for (var j = 0; j < n.length; j++) {
          if (n[j].nodeType === 1 && (n[j].matches('.zh-offer') || n[j].querySelector('.zh-offer'))) { eqSoon(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  window.__eqOffers = eqSoon;

  function wire(form) {
    if (form.__brandCardWired) { return; }
    form.__brandCardWired = true;

    var planInput = form.querySelector('[data-zh-plan-input]');

    /* Real product cards are a <form>: add via AJAX and open the side drawer
       instead of a full-page POST to /cart. */
    if (form.tagName === 'FORM' && window.zpAddToCart) {
      form.addEventListener('submit', function (e) {
        var idInput = form.querySelector('[name="id"]');
        var vid = idInput && idInput.value;
        if (!vid) { return; }
        e.preventDefault();
        var qtyInput = form.querySelector('[name="quantity"]');
        var qty = qtyInput ? (Number(qtyInput.value) || 1) : 1;
        var plan = (planInput && !planInput.disabled && planInput.value) ? planInput.value : null;
        window.zpAddToCart(vid, qty, plan, e.submitter || form.querySelector('[type="submit"]'));
      });

      /* The CTA ships as type="submit", but by the time it reaches the page
         something has rewritten it to type="button" — so the submit listener
         above never fired. The item still ended up in the cart (another script
         on the page was picking the click up), but the drawer never opened and
         the header count went stale, so the shopper got no sign anything had
         happened. Worse, Zipify OneClickUpsell sometimes read the same click as
         a buy-now and redirected to checkout a few seconds later.

         Binding the click directly, in the capture phase, means the card always
         adds through zpAddToCart: AJAX, drawer opens, sections re-render.
         stopImmediatePropagation keeps anything else from acting on it. */
      Array.prototype.forEach.call(form.querySelectorAll('.zh-card-cta'), function (cta) {
        if (cta.tagName !== 'BUTTON' || cta.disabled) { return; }
        cta.addEventListener('click', function (e) {
          var idInput = form.querySelector('[name="id"]');
          var vid = idInput && idInput.value;
          if (!vid) { return; }
          e.preventDefault();
          e.stopImmediatePropagation();
          var qtyInput = form.querySelector('[name="quantity"]');
          var qty = qtyInput ? (Number(qtyInput.value) || 1) : 1;
          var plan = (planInput && !planInput.disabled && planInput.value) ? planInput.value : null;
          window.zpAddToCart(vid, qty, plan, cta);
        }, true);
      });
    }

    var opts = form.querySelectorAll('[data-zh-opt]');
    if (!opts.length) { return; }

    var planId = planInput ? planInput.value : null;
    var cta = form.querySelector('[data-zh-cta]');
    var perday = form.querySelector('[data-zh-perday]');
    var ship = form.querySelector('[data-zh-ship]');
    var note = form.querySelector('[data-zh-note]');

    Array.prototype.forEach.call(opts, function (opt) {
      var radio = opt.querySelector('input[type="radio"]');
      if (!radio) { return; }
      radio.addEventListener('change', function () {
        Array.prototype.forEach.call(opts, function (o) {
          o.classList.toggle('is-active', o === opt);
        });
        if (cta) { cta.innerHTML = radio.getAttribute('data-cta') || cta.innerHTML; }
        if (perday) { perday.textContent = radio.getAttribute('data-perday') || ''; }
        if (ship) { ship.textContent = radio.getAttribute('data-ship') || ''; }
        if (note) { note.innerHTML = radio.getAttribute('data-note') || ''; }
        if (planInput) {
          /* A one-time order must not carry a selling plan. */
          planInput.disabled = opt.getAttribute('data-zh-opt') === 'once';
          planInput.value = planInput.disabled ? '' : planId;
        }
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.zh-buy'), wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme editor re-renders, and any grid that swaps cards in. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('brand:defer:open', init);
})();
